import { render } from "./Clicker.vue?vue&type=template&id=5b477855&scoped=true"
import script from "./Clicker.vue?vue&type=script&lang=js"
export * from "./Clicker.vue?vue&type=script&lang=js"

import "./Clicker.vue?vue&type=style&index=0&id=5b477855&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/futurefest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b477855"]])

export default __exports__